export function Form(): JSX.Element {
  const url = `${process.env.NEXT_PUBLIC_HOMEPAGE_URI}/f/${process.env.NEXT_PUBLIC_CONTACT_FORM_ID}`

  return (
    <iframe
      src={url}
      frameBorder="none"
      className="object-fill w-full h-screen"
    />
  )
}
